import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

const ContentLayout = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box sx={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <Header />
      <Sidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
     <Box
  sx={{
    position: 'relative',
    marginTop: '75px',
    height: 'calc(100vh - 75px)',
    transition: 'all 0.3s ease',
    backgroundColor: '#f0f0f0',
    overflow: 'auto',
  }}
>
  <Outlet context={{ isSidebarExpanded: isExpanded }} />
</Box>

    </Box>
  );
};

export default ContentLayout;
